<template>
  <div>
    <vs-popup
      class="deliverer-modal"
      :title="title"
      :active.sync="showPopup"
      v-if="contact !== null"
    >
      <template>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Naam"
              :value="contact.firstname"
              v-model="contact.firstname"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Tussenvoegsel"
              :value="contact.insertion"
              v-model="contact.insertion"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Achternaam"
              :value="contact.lastname"
              v-model="contact.lastname"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              type="email"
              label="E-mail"
              :value="contact.email"
              v-model="contact.email"
            />
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              label="Telefoonnummer"
              :value="contact.phone_number"
              v-model="contact.phone_number"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              class="mr-3 mb-2"
              @click="saveCompanyContact(contact, false)"
              style="text-align: right"
            >Opslaan</vs-button>
            <vs-button
              class="mr-3 mb-2"
              @click="deleteContact(contact)"
              style="text-align: right"
            >Verwijderen</vs-button>
            <vs-button
              class="mr-3 mb-2"
              @click="resetPassword(contact.email)"
              style="text-align: right"
              v-if="staffRoute"
            >Reset wachtwoord mail</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>
    <vs-popup class="deliverer-modal" :title="createTitle" :active.sync="showCreatePopup">
      <template>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              name="Firstname"
              label="Naam"
              :value="createContact.firstname"
              v-model="createContact.firstname"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Firstname')"
            >{{ errors.first('Firstname') }}</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Tussenvoegsel"
              :value="createContact.insertion"
              v-model="createContact.insertion"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Achternaam"
              :value="createContact.lastname"
              v-model="createContact.lastname"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              type="email"
              label="E-mail"
              :value="createContact.email"
              v-model="createContact.email"
            />
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              ete
              label="Telefoonnummer"
              :value="createContact.phone_number"
              v-model="createContact.phone_number"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              class="mr-3 mb-2"
              @click="saveCompanyContact(createContact, true)"
              style="text-align: right"
            >Opslaan</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>
<script>
export default {
  name: "ht-contact-popup",
  data() {
    return {
      showPopup: false,
      showCreatePopup: false,
      contact: null,
      saved: false,
      current: null,
      createContact: {
        firstname: "",
        insertion: "",
        lastname: "",
        email: null,
        phone_number: null,
      },
    };
  },

  watch: {
    showPopup: function () {
      if (this.saved) {
        this.saved = false;
        return;
      }
      if (this.current === JSON.stringify(this.contact)) {
        return;
      }
      if (!this.showPopup) {
        this.current = JSON.stringify(this.contact);
        this.saveCompanyContact(this.contact);
      }
    },
  },
  computed: {
    title: function () {
      if (this.contact.firstname === null) {
        return "Vul een naam in";
      }
      return (
        this.contact.firstname +
        " " +
        (this.contact.insertion !== null ? this.contact.insertion + " " : "") +
        this.contact.lastname
      );
    },
    staffRoute: function() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
        return false;
      }
    },
    createTitle: function () {
      if (this.createContact.firstname === "") {
        return "Vul een naam in";
      }
      return (
        this.createContact.firstname +
        " " +
        (this.createContact.insertion !== null
          ? this.createContact.insertion + " "
          : "") +
        this.createContact.lastname
      );
    },
  },
  methods: {
    resetPassword(email) {
      let data = {
        _method: "POST",
        email: email,
      };
      let url =
        "https://companyapi.hebtrek.nl/v1/company-contact/reset-password";
      this.$http
        .post(url, data, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("companytoken")),
          },
        })
        .then((response) => {
          this.$vs.notify({
            title: "Gelukt!",
            text: "We hebben een mailtje verstuurd met instructies",
            color: "green",
            position: "top-center",
            fixed: true,
          });
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
    saveCompanyContact(contact, create) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
        } else {
          return;
        }
      });
      let data = {
        _method: create ? "POST" : "PUT",
        id: contact.id,
        firstname: contact.firstname,
        insertion: contact.insertion,
        lastname: contact.lastname,
        phone_number: contact.phone_number,
        email: contact.email,
        company_contact_role_id: create ? 1 : contact.company_contact_role_id,
        slug: this.$route.params.slug,
      };
      let url = create
        ? (this.staffRoute ? "https://staffapi.hebtrek.nl/v1/company/company-contact/create" : "https://companyapi.hebtrek.nl/v1/company/company-contact/create")
        : (this.staffRoute ? "/v1/company-contact/update" : "https://companyapi.hebtrek.nl/v1/company-contact/update");
      let token = this.staffRoute
              ? JSON.parse(localStorage.getItem("stafftoken"))
              : JSON.parse(localStorage.getItem("companytoken"));
      this.$http
        .post(url, data, {
          headers: {
            Authorization:
              "Bearer " + token,
          },
        })
        .then(() => {
          this.saved = true;
          this.showCreatePopup = false;
          this.showPopup = false;
          this.$events.fire("refresh-contacts");
          this.$vs.notify({
            title: "Gelukt!",
            text: "Gegevens voor " + contact.firstname + " zijn opgeslagen!",
            color: "green",
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
    deleteContact(contact) {
      let data = {
        _method: "DELETE",
        id: contact.id,
      };

      let url = this.staffRoute
              ? "https://staffapi.hebtrek.nl/v1/company/" +
              this.$route.params.slug +
              "/company-contact/delete"
              : "https://companyapi.hebtrek.nl/v1/company/" +
              this.$route.params.slug +
              "/company-contact/delete";
      this.$http
        .post(url, data, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
          },
        })
        .then((response) => {
          this.showPopup = false;
          this.$events.fire("refresh-contacts");
          this.$vs.notify({
            title: "Gelukt!",
            text: contact.firstname + " verwijderd",
            color: "green",
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
  },

  mounted() {
    this.$events.listen('open-contact-popup', (event) => {
      this.contact = event;
      this.showPopup = true;
      this.current = JSON.stringify(this.contact);
    });
    this.$events.listen('open-create-contact-popup', () => {
      this.showCreatePopup = true;
    });
    window.addEventListener('keyup', (key) => {
      if (key.keyCode === 27) {
        this.showCreatePopup = false;
        this.showPopup = false;
      }
    });
  },
};
</script>
